import {Tag} from "antd";
import React from 'react';

interface Props {
  labels?: string[];
  name: string;
  calculation: string;
}

const PaymentLineComponent: React.FC<Props> = ({ labels, name, calculation }) => {
  return (
    <div>
      {labels && labels.length > 0 && (
        <>
          {labels.map((x, index) => (
            <Tag key={index} color='#87d068'>
              {x}
            </Tag>
          ))}
        </>
      )}
      <strong>{name}:</strong> {calculation}
    </div>
  );
};

export { PaymentLineComponent };
